<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
--> 

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${currentHeroImage})` }">
        <div class="hero-overlay">
          <div class="hero-title">Healthy Living Starts with Premium Dry Fruits</div>
          <div class="hero-desc">
            Handpicked almonds, cashews, dates and superfoods sourced from the finest farms. Nourish your body with natural energy, protein, and goodness — one handful at a time.
          </div>
          <router-link class="hero-btn" to="/goods">Shop Now</router-link>
        </div>
        <div class="hero-dots">
          <span
            v-for="(img, idx) in heroImages"
            :key="idx"
            class="hero-dot"
            :class="{ active: heroIndex === idx }"
            @click="setHeroIndex(idx)"
          ></span>
        </div>
      </div>
    </div>

    <!-- Category Products Section -->
    <div class="main-box">
      <div class="main">
        <div class="section-header">
          <h2>New Arrivals</h2>
          <p>Fresh dry fruits &amp; nuts just for you</p>
        </div>
        <div class="category-products">
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Why Shop With Us -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">🚚</div>
            <h3>Free Shipping</h3>
            <p>On orders above ₹499</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🌿</div>
            <h3>100% Natural</h3>
            <p>No added sugar or preservatives</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🔄</div>
            <h3>Easy Returns</h3>
            <p>7-day hassle-free returns</p>
          </div>
          <div class="why-item">
            <div class="why-icon">💳</div>
            <h3>Secure Payment</h3>
            <p>UPI, COD &amp; cards accepted</p>
          </div>
        </div>

        <!-- Discover Section -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Curated Dry Fruits &amp; Superfoods</h2>
              <p>Handpicked goodness for every healthy routine</p>
            </div>
            <div class="section-tabs">
              <span class="tab-item" :class="{active: discoverActive==='ALMONDS'}" @click="discoverActive='ALMONDS'">ALMONDS</span>
              <span class="tab-item" :class="{active: discoverActive==='CASHEW'}" @click="discoverActive='CASHEW'">CASHEW</span>
              <span class="tab-item" :class="{active: discoverActive==='DATES'}" @click="discoverActive='DATES'">DATES</span>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
          <router-link class="section-cta" to="/goods">See More</router-link>
        </div>

        <!-- Full Width Promo Banner -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">Limited Time Offer</span>
            <h2>HEALTHY HARVEST 2026</h2>
            <p>Up to 40% Off on Premium Dry Fruits &amp; Superfood Mixes</p>
            <router-link class="promo-btn" to="/goods">Shop Now</router-link>
          </div>
          <div class="promo-image">
            <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop8/9500024/img_00.png" alt="Premium Dates" />
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Premium Dates</div>
              <div class="split-desc">
                Handpicked Saudi Mabroom and Iraqi dates — nature's caramel-rich superfood for instant energy and iron.
              </div>
              <router-link class="section-cta" to="/goods">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop8/9500024/img_01.png" alt="Premium Dates" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Trail Mix &amp; Panchmeva</div>
              <div class="split-desc">
                Nine superfoods in one jar — almonds, cashews, raisins, flax and pumpkin seeds for daily wellness.
              </div>
              <router-link class="section-cta" to="/goods">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop8/9500002/img_00.png" alt="Trail Mix" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as productsAPI from '@/api/products/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据（后端接口，已忽略：旧数据为女装图，不适配坚果主题）
      // Dry-fruits category product lists (4 slots for the homepage grid)
      almondsList: [],     // 500
      cashewList: [],      // 501
      datesList: [],       // 504
      raisinsList: [],     // 506
      discoverActive: 'ALMONDS', // Discover section active tab
      almondsProdList: [],
      cashewProdList: [],
      datesProdList: [],
      // Hero 轮播：硬编码的干果图片池（OSS shop8 路径）
      heroImages: [
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop8/9500024/img_00.png', // Mabroom Dates
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop8/9500001/img_00.png', // Roasted Salted Almonds
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop8/9500007/img_00.png', // Roasted Salted Cashews
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop8/9500002/img_00.png', // Trail Mix (9 Superfoods)
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop8/9500006/img_00.png'  // Panchmeva
      ],
      heroIndex: 0,
      heroTimer: null,
      start: 0,
      limit: 7,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8
    }
  },
  computed: {
    currentHeroImage() {
      // 直接使用坚果图池，忽略后端 carousels（后端数据为旧女装图，不适用）
      return this.heroImages[this.heroIndex] || this.heroImages[0]
    },
    discoverProducts() {
      if (this.discoverActive === 'ALMONDS') return this.almondsProdList
      if (this.discoverActive === 'CASHEW') return this.cashewProdList
      return this.datesProdList
    }
  },
  activated() {
    // 获取首页数据
    this.load()
    this.startHeroRotation()
  },
  deactivated() {
    this.stopHeroRotation()
  },
  beforeDestroy() {
    this.stopHeroRotation()
  },
  methods: {
    // Hero 轮播控制
    setHeroIndex(idx) {
      this.heroIndex = idx
    },
    startHeroRotation() {
      this.stopHeroRotation()
      if (!this.heroImages || this.heroImages.length < 2) return
      this.heroTimer = setInterval(() => {
        this.heroIndex = (this.heroIndex + 1) % this.heroImages.length
      }, 5000)
    },
    stopHeroRotation() {
      if (this.heroTimer) {
        clearInterval(this.heroTimer)
        this.heroTimer = null
      }
    },
    load() {
      // 不再请求后端 carousels 接口（旧数据为女装图，与坚果主题不兼容）。
      // Hero 轮播由硬编码的 heroImages 图池提供。
      // 首页类目：取导航“Shop Now”同源分类
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
            this.activeCategoryId = 0
            this.fetchHomeProducts(0)

            // Discover section: dry-fruits categories
            this.findDiscoverCategories(list)
          } else {
            this.notifyError('Failed to obtain classification', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })
      // Discover section: dry-fruits category product lists
      this.getProduct(500, 'almondsProdList')  // Almonds
      this.getProduct(501, 'cashewProdList')   // Cashew
      this.getProduct(504, 'datesProdList')    // Dates
    },
    // Find dry-fruits categories for the Discover section
    findDiscoverCategories(list) {
      const almondsCat = list.find(c => (c.category_name || '').toLowerCase() === 'almonds')
      if (almondsCat) this.getProduct(almondsCat.category_id, 'almondsProdList')

      const cashewCat = list.find(c => (c.category_name || '').toLowerCase() === 'cashew')
      if (cashewCat) this.getProduct(cashewCat.category_id, 'cashewProdList')

      const datesCat = list.find(c => (c.category_name || '').toLowerCase() === 'dates')
      if (datesCat) this.getProduct(datesCat.category_id, 'datesProdList')
    },
    selectCategory(id) {
      if (this.activeCategoryId === id) return
      this.activeCategoryId = id
      this.homeStart = 0
      this.fetchHomeProducts(id)
    },
    fetchHomeProducts(categoryId) {
      productsAPI
        .listProducts(categoryId, this.homeStart, this.homeLimit)
        .then(res => {
          if (res.status === 200) {
            this.homeProducts = this.shuffle(Array.isArray(res.data.items) ? res.data.items : [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // 获取各类商品数据方法封装
    getProduct(categoryID, val) {
      productsAPI
        .listProducts(categoryID, this.start, this.limit)
        .then(res => {
          if (res.status === 200) {
            this[val] = this.shuffle(res.data.items || [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle
    shuffle(array) {
      const arr = [...array]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FFFBEB')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FFFBEB')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';
</style>
